import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 0;
  width: 100%;
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background-color: ${({ disabled }) => (disabled ? '#f3f3f5' : '#5768ff')};
  color: ${({ disabled }) => (disabled ? '#d6d6d6' : '#fff')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    background-color: #4557e8;
    transform: scale(1.05);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  svg {
    font-size: 16px;
  }
`;

export const PageNumber = styled.button<{ isActive?: boolean }>`
  width: 30px;
  height: 28px;
  border-radius: 8px;
  border: ${({ isActive }) => (isActive ? 'none' : '1px solid #d6d6d6')};
  background-color: ${({ isActive }) => (isActive ? '#5768ff' : '#fff')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#101010')};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: ${({ isActive }) => (isActive ? '600' : '500')};
  transition: all 0.2s ease;
  font-family: 'DM Sans', sans-serif;

  &:hover {
    background-color: ${({ isActive }) => (isActive ? '#4557e8' : '#f0f2ff')};
    border-color: ${({ isActive }) => (isActive ? 'none' : '#5768ff')};
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;
